import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const TextSizeListItem = (props) => {
    const { textElementFontSize, index, updateTextElement, maxFontSize } = props;

    const onTextSizeChange = (value) => {
        previewHistoryBatch.start();
        updateTextElement(index, { fontSize: value });
    };
    
    return (
        <SliderListItem
            title='Size'
            value={textElementFontSize}
            displayMultiplier={1}
            min={1}
            max={maxFontSize}
            step={1}
            onValueChange={onTextSizeChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { fontSize: textElementFontSize } = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    const { maxFontSize } = state.create.maxValues;

    return { 
        textElementFontSize,
        maxFontSize
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextSizeListItem);